import {
  AppShell,
  Container,
  Group,
  Header,
  Image,
  Navbar,
  NavLink,
  useMantineTheme,
} from '@mantine/core';
import {
  IconBuildingStore,
  IconUserCheck,
  IconUsers,
} from '@tabler/icons-react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';

import logo from '../assets/images/logo/CMYK/logo/png/Juice_Primary_Logo.png';
import { UserMenu } from '../components/_userMenu';

function AdminLayout2({ setTheme }) {
  const theme = useMantineTheme();
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    {
      label: 'Users',
      path: '/admin/users',
      icon: IconUsers,
    },
    {
      label: 'Approvers',
      path: '/admin/approvers',
      icon: IconUserCheck,
    },
    {
      label: 'Vendors',
      path: '/admin/vendors',
      icon: IconBuildingStore,
    },
  ];

  return (
    <AppShell
      styles={{
        main: {
          background:
            theme.colorScheme === 'dark'
              ? theme.colors.dark[8]
              : theme.colors.gray[1],
        },
      }}
      navbarOffsetBreakpoint="sm"
      asideOffsetBreakpoint="sm"
      header={
        <Header height={64} py="xs">
          <Container fluid>
            <Group position="start">
              {/* Logo */}
              <Image
                width={150}
                maw={150}
                mt="-4px"
                radius="md"
                src={logo}
                alt="Logo"
                onClick={() => navigate('/')}
              />
            </Group>
          </Container>
        </Header>
      }
      navbar={
        <Navbar hiddenBreakpoint="sm" hidden={true} width={{ base: 240 }}>
          <Navbar.Section grow mt="md">
            {/* Admin Navigation Menu */}
            {menuItems.map((item) => (
              <NavLink
                key={item.path}
                label={item.label.toUpperCase()}
                component={Link}
                to={item.path}
                icon={<item.icon size="1rem" stroke={1.5} />}
                active={location.pathname === item.path}
                color="cyan"
                variant="filled"
              />
            ))}
          </Navbar.Section>
          <Navbar.Section>
            <UserMenu setTheme={setTheme} />
          </Navbar.Section>
        </Navbar>
      }>
      <Outlet />
    </AppShell>
  );
}

export default AdminLayout2;
